<script setup lang="ts">
import { capitalize } from '@sancare/typescript-commons/src/misc/string-utils'
import { FilterDataValue } from '@sancare/typescript-commons/src/types/filters'
import { ref, watch } from 'vue'

import { FilterData } from '@/store/modules/filters/types'

interface TextCriteriaProps{
  filterData: FilterData
  initialValue?: FilterDataValue | null
  isAdvancedSearch: boolean
}

const props = withDefaults(defineProps<TextCriteriaProps>(), {
  initialValue: null,
})

const emit = defineEmits<{
  (e: 'add-filter', param: { name:string, type:string, value:string })
}>()

const initSubFiltersValues = () => {
  const subFiltersValues = {}

  if (props.filterData.subFilters) {
    props.filterData.subFilters.forEach((filter) => {
      if (filter.default) {
        subFiltersValues[filter.name] = filter.default
      } else {
        subFiltersValues[filter.name] = filter.options ? filter.options[0] : ''
      }
    })
  }
  return subFiltersValues
}

const initializeFromInitialValue = () => {
  if (!props.initialValue)
    return

  if (typeof props.initialValue === 'string') {
    defaultFilterValue.value = props.initialValue
    return
  }

  defaultFilterValue.value = props.initialValue.value || ''

  if (props.initialValue.subFilters) {
    subFiltersValues.value = {
      ...initSubFiltersValues(),
      ...props.initialValue.subFilters,
    }
  }
}

const subFiltersValues = ref(initSubFiltersValues())
const defaultFilterValue = ref<string>(props.filterData.default || '')

const addFilter = () => {
  if (!defaultFilterValue.value || !defaultFilterValue.value.trim())
    return

  const presence = 'present'
  const name = props.filterData.name
  let type = props.filterData.name
  type = capitalize(type)
  type = `${presence}${type}`
  const value = defaultFilterValue.value

  emit('add-filter', { name, type, value })
}

watch(
  () => props.initialValue,
  () => initializeFromInitialValue(),
  { immediate: true }
)
</script>

<template>
  <div class="row">
    <div
      :class="{
        'col-4': !isAdvancedSearch,
        'col-12': isAdvancedSearch
      }"
      class="input-group"
    >
      <select
        v-for="filter in filterData.subFilters"
        :id="`text-criteria-sub-${filter.name}`"
        :key="filter.name"
        v-model="subFiltersValues[filter.name]"
        class="form-select"
      >
        <option
          v-for="opt in filter.options"
          :key="opt"
          :value="opt"
        >
          {{ filter.labels[opt] ? filter.labels[opt] : opt }}
        </option>
      </select>
      <input
        id="text-criteria-input"
        v-model="defaultFilterValue"
        name="presentTitleCriteria_input"
        class="form-control col p-1"
        @keyup.enter="addFilter"
      >
      <div class="input-group-append">
        <button
          id="text-criteria-add"
          class="btn btn-primary"
          type="button"
          @click="addFilter"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</template>
